import type { LocationState } from '@ps/web-core-store';
import type { LocationDescriptor } from 'history';
import { useCallback, useContext } from 'react';

import { RootHistoryContext } from '../../RootHistoryContextProvider/RootHistoryContextProvider';

export const useNavigate = () => {
  const history = useContext(RootHistoryContext);

  return useCallback(
    (path: string | LocationDescriptor<LocationState>) => history?.push(path),
    [history]
  );
};
